import { useState, useEffect } from 'react';

export enum ScreenSize {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop'
}

export function useScreenSize() {
  const [screenSize, setScreenSize] = useState<ScreenSize>(() => {
    return getScreenSize(window.innerWidth);
  });

  function getScreenSize(width: number): ScreenSize {
    if (width < 751) return ScreenSize.MOBILE;
    return ScreenSize.DESKTOP;
  }

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(getScreenSize(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
}